import type { AspectRatio } from '@uncinc/react-drupal-core/dist/Components/DynamicMediaItem';
import type { SearchAllContentHit } from '../components/SearchAllContent/types';

import {
  SCREEN_XS,
  SCREEN_SM,
  SCREEN_MD,
  SCREEN_LG,
  SCREEN_XL,
} from '../config/constants';

function constructVariableRatiosImageSourcesObject(
  hit: SearchAllContentHit,
  aspectRatio: [AspectRatio, AspectRatio, AspectRatio, AspectRatio, AspectRatio],
  cropSizes: [string, string, string, string, string] = ['xxs', 'xs', 'sm', 'md', 'md'],
) {
  // For indexing image ratios, we use custom fields in the ES index.
  // The tokens for this differ between entity type.
  let prefix = '';

  switch (hit.entity_type[0]) {
    case 'profile':
      prefix = 'profile_';
      break;
    case 'taxonomy_term':
      prefix = 'taxonomy_teaser_';
      break;
    default:
      break;
  }

  return {
    [SCREEN_XS]: (hit[`${prefix}image_ratio_${aspectRatio[0]}_${cropSizes[0]}`] as [string])?.[0] ?? '',
    [SCREEN_SM]: (hit[`${prefix}image_ratio_${aspectRatio[1]}_${cropSizes[1]}`] as [string])?.[0] ?? '',
    [SCREEN_MD]: (hit[`${prefix}image_ratio_${aspectRatio[2]}_${cropSizes[2]}`] as [string])?.[0] ?? '',
    [SCREEN_LG]: (hit[`${prefix}image_ratio_${aspectRatio[3]}_${cropSizes[3]}`] as [string])?.[0] ?? '',
    [SCREEN_XL]: (hit[`${prefix}image_ratio_${aspectRatio[4]}_${cropSizes[4]}`] as [string])?.[0] ?? '',
  };
}

export default constructVariableRatiosImageSourcesObject;
